/*
 * Emily Editions : fiche produit, retours de Charlotte du 2026-09-26.
 *
 * Deux choses :
 *   1. le guide des tailles dans un panneau, depuis le lien pose a cote du
 *      choix de la taille ;
 *   2. la barre d'achat collante s'efface pendant la lecture des details.
 *
 * La visionneuse de l'apercu a ete retiree au report : le theme a la sienne,
 * a activer dans Personnaliser > fiche produit > galerie > zoom.
 *
 * Dans le personnalisateur, chaque reglage modifie redessine la section
 * concernee sans recharger la page : tout ce qui suit est donc relance a
 * l'evenement shopify:section:load, et chaque etape sait reconnaitre ce
 * qu'elle a deja pose pour ne rien doubler.
 */
(function () {
  'use strict';

  var ICONE_CROIX =
    '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M13 3 3 13M13 13 3 3" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>';

  /* ------------------------------------------------------------------ */
  /* 2. Le guide des tailles dans un panneau                             */
  /* ------------------------------------------------------------------ */
  var panneau = null;
  var sourcePanneau = null;

  var fermerPanneau = function () {
    if (panneau && panneau.open) panneau.close();
  };

  var poserGuide = function () {
    var source = document.querySelector('.ee-fiche-details [data-ee-guide]');
    if (!source || !('HTMLDialogElement' in window)) return;

    // Section redessinee : le guide a pu changer, le panneau est refait
    if (source !== sourcePanneau) {
      if (panneau) panneau.remove();
      sourcePanneau = source;

      // Le titre du panneau est l'intitule du volet, regle dans la section
      // « EE Details bas fiche » (data-ee-guide-titre pose par le Liquid).
      var titreGuide = source.getAttribute('data-ee-guide-titre') || 'Guide des tailles';
      panneau = document.createElement('dialog');
      panneau.className = 'ee-guide-dialog';
      panneau.setAttribute('aria-labelledby', 'ee-guide-dialog-titre');
      panneau.innerHTML =
        '<div class="ee-guide-dialog__entete">' +
        '<h2 class="ee-guide-dialog__titre" id="ee-guide-dialog-titre"></h2>' +
        '<button type="button" class="ee-guide-dialog__fermer">' + ICONE_CROIX + '</button>' +
        '</div>' +
        '<div class="ee-guide-dialog__corps"></div>';
      panneau.querySelector('.ee-guide-dialog__titre').textContent = titreGuide;
      panneau.querySelector('.ee-guide-dialog__fermer').setAttribute('aria-label', 'Fermer : ' + titreGuide);
      panneau.querySelector('.ee-guide-dialog__corps').appendChild(source.cloneNode(true));
      document.body.appendChild(panneau);

      panneau.querySelector('.ee-guide-dialog__fermer').addEventListener('click', fermerPanneau);

      // Un clic sur le voile, hors du panneau, le referme
      panneau.addEventListener('click', function (e) {
        if (e.target !== panneau) return;
        var r = panneau.getBoundingClientRect();
        var dedans = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
        if (!dedans) fermerPanneau();
      });
    }

    document.querySelectorAll('[data-ee-guide-ouvrir]').forEach(function (lien) {
      if (lien.dataset.eeGuidePose) return;
      lien.dataset.eeGuidePose = 'oui';
      lien.addEventListener('click', function (e) {
        // le lien est dans la legende du choix de taille : il ne doit rien cocher
        e.preventDefault();
        e.stopPropagation();
        if (panneau) panneau.showModal();
      });
    });
  };

  /* ------------------------------------------------------------------ */
  /* 3. La barre d'achat collante s'efface pendant la lecture            */
  /* ------------------------------------------------------------------ */
  // La barre et la section de lecture sont cherchees a chaque passage :
  // apres un redessin, ce sont de nouveaux elements.
  var dernierY = window.pageYOffset;
  var cache = false;

  var surLaLecture = function (lecture) {
    if (!lecture) return false;
    var r = lecture.getBoundingClientRect();
    var h = window.innerHeight;
    // la section occupe le milieu de l'ecran : on est en train de la lire
    return r.top < h * 0.55 && r.bottom > h * 0.35;
  };

  var evaluer = function () {
    var barre = document.querySelector('.sticky-add-to-cart__bar');
    if (!barre) return;
    var y = window.pageYOffset;
    var ecart = y - dernierY;
    var basDePage = window.innerHeight + y >= document.documentElement.scrollHeight - 320;

    if (ecart > 4) cache = true;
    else if (ecart < -4) cache = false;
    if (basDePage) cache = false;
    if (surLaLecture(document.querySelector('.ee-fiche-details'))) cache = true;

    barre.toggleAttribute('data-ee-cache', cache);
    dernierY = y;
  };

  /* ------------------------------------------------------------------ */
  /* 4. « Tout savoir sur ce produit » en onglets, sur telephone         */
  /* ------------------------------------------------------------------ */
  /*
   * La maquette telephone remplace la pile de volets par une grille de
   * boutons et une seule carte a la fois. Les boutons sont construits ici
   * a partir des intitules des volets (donc de la description saisie dans
   * l'admin, noms courts regles dans le personnalisateur) et portent la classe « desktop:hidden » du theme : sur
   * ordinateur ils n'existent pas a l'oeil, et toute la mise en forme des
   * onglets vit sous la requete telephone de ee-design-fiche.css. Les
   * volets eux-memes ne changent pas de balise.
   */
  var telephone = window.matchMedia('(max-width: 749px)');

  // Intitule court de la maquette : calcule par le Liquid d'apres les mots
  // de l'intertitre et regle dans la section « EE Details bas fiche »
  // (attribut data-ee-court) ; a defaut, l'intertitre tel qu'il est saisi.
  var intituleCourt = function (volet, texte) {
    return volet.getAttribute('data-ee-court') || texte;
  };

  var poserOnglets = function () {
    var bande = document.querySelector('.ee-fiche-details .ee-details');
    if (!bande || bande.dataset.eeOnglets) return;

    var volets = Array.prototype.filter.call(bande.children, function (el) {
      return el.classList.contains('ee-details__volet');
    });
    if (volets.length < 2) return;
    bande.dataset.eeOnglets = 'poses';

    var grille = document.createElement('div');
    grille.className = 'ee-onglets desktop:hidden';
    var boutons = [];

    var choisir = function (index, focus) {
      volets.forEach(function (volet, j) {
        var actif = j === index;
        volet.toggleAttribute('data-ee-actif', actif);
        boutons[j].setAttribute('aria-expanded', actif ? 'true' : 'false');
        // Un volet ferme par reglage s'ouvre quand on choisit son onglet,
        // sur telephone seulement : l'ordinateur garde l'etat choisi.
        if (actif && telephone.matches) volet.open = true;
      });
      if (focus) boutons[index].focus();
    };

    volets.forEach(function (volet, i) {
      var titre = volet.querySelector('.ee-details__titre');
      var texte = titre ? titre.textContent.trim() : '';
      if (!volet.id) volet.id = 'ee-volet-' + i;

      var bouton = document.createElement('button');
      bouton.type = 'button';
      bouton.className = 'ee-onglets__bouton';
      bouton.textContent = intituleCourt(volet, texte);
      // Le nom lu commence par l'intitule visible (« Matiere : Une viscose... ») :
      // qui dicte « Matiere » a son logiciel vocal trouve bien le bouton.
      if (bouton.textContent !== texte) bouton.setAttribute('aria-label', bouton.textContent + ' : ' + texte);
      bouton.setAttribute('aria-controls', volet.id);
      bouton.addEventListener('click', function () {
        choisir(i, false);
      });
      boutons.push(bouton);
      grille.appendChild(bouton);
    });

    bande.parentNode.insertBefore(grille, bande);
    bande.classList.add('ee-details--onglets');
    choisir(0, false);
  };

  // Passage de l'ordinateur au telephone (rotation, fenetre reduite) :
  // l'onglet choisi doit montrer son contenu.
  var surChangement = function () {
    if (!telephone.matches) return;
    var actif = document.querySelector('.ee-fiche-details .ee-details__volet[data-ee-actif]');
    if (actif) actif.open = true;
  };

  var demarrer = function () {
    poserGuide();
    poserOnglets();
    evaluer();
  };

  demarrer();
  window.addEventListener('scroll', evaluer, { passive: true });
  window.addEventListener('resize', evaluer, { passive: true });
  if (telephone.addEventListener) telephone.addEventListener('change', surChangement);
  document.addEventListener('shopify:section:load', demarrer);
})();
